/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  ToTeachWorksheetImportBatchInput,
  ToTeachWorksheetImportBatchQueued,
  ToTeachWorksheetImportInput,
  ToTeachWorksheetImportQueued
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Import a ToTeach worksheet as a Fobizz worksheet
 */
export const createToTeachWorksheetImport = (
    toTeachWorksheetImportInput: MaybeRefOrGetter<ToTeachWorksheetImportInput>,
 signal?: AbortSignal
) => {
      toTeachWorksheetImportInput = toValue(toTeachWorksheetImportInput);

      return axiosClient<ToTeachWorksheetImportQueued>(
      {url: `/to_teach/worksheet_imports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: toTeachWorksheetImportInput, signal
    },
      );
    }




export const getCreateToTeachWorksheetImportMutationKey = () => ['createToTeachWorksheetImport'] as const;

export const getCreateToTeachWorksheetImportMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToTeachWorksheetImport>>, TError,CreateToTeachWorksheetImportMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createToTeachWorksheetImport>>, TError,CreateToTeachWorksheetImportMutationVariables, TContext> => {

const mutationKey = getCreateToTeachWorksheetImportMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createToTeachWorksheetImport>>, CreateToTeachWorksheetImportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createToTeachWorksheetImport(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateToTeachWorksheetImportMutationResult = NonNullable<Awaited<ReturnType<typeof createToTeachWorksheetImport>>>
    export type CreateToTeachWorksheetImportMutationBody = ToTeachWorksheetImportInput
    export type CreateToTeachWorksheetImportMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateToTeachWorksheetImportMutationVariables = {data: ToTeachWorksheetImportInput}

    /**
 * @summary Import a ToTeach worksheet as a Fobizz worksheet
 */
export const useCreateToTeachWorksheetImport = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToTeachWorksheetImport>>, TError,CreateToTeachWorksheetImportMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createToTeachWorksheetImport>>,
        TError,
        CreateToTeachWorksheetImportMutationVariables,
        TContext
      > => {
      return useMutation(getCreateToTeachWorksheetImportMutationOptions(options), queryClient);
    }
    /**
 * @summary Queue a batch of ToTeach worksheet imports for the current user
 */
export const createToTeachWorksheetImportBatch = (
    toTeachWorksheetImportBatchInput: MaybeRefOrGetter<ToTeachWorksheetImportBatchInput>,
 signal?: AbortSignal
) => {
      toTeachWorksheetImportBatchInput = toValue(toTeachWorksheetImportBatchInput);

      return axiosClient<ToTeachWorksheetImportBatchQueued>(
      {url: `/to_teach/worksheet_imports/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: toTeachWorksheetImportBatchInput, signal
    },
      );
    }




export const getCreateToTeachWorksheetImportBatchMutationKey = () => ['createToTeachWorksheetImportBatch'] as const;

export const getCreateToTeachWorksheetImportBatchMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToTeachWorksheetImportBatch>>, TError,CreateToTeachWorksheetImportBatchMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createToTeachWorksheetImportBatch>>, TError,CreateToTeachWorksheetImportBatchMutationVariables, TContext> => {

const mutationKey = getCreateToTeachWorksheetImportBatchMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createToTeachWorksheetImportBatch>>, CreateToTeachWorksheetImportBatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createToTeachWorksheetImportBatch(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateToTeachWorksheetImportBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createToTeachWorksheetImportBatch>>>
    export type CreateToTeachWorksheetImportBatchMutationBody = ToTeachWorksheetImportBatchInput
    export type CreateToTeachWorksheetImportBatchMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateToTeachWorksheetImportBatchMutationVariables = {data: ToTeachWorksheetImportBatchInput}

    /**
 * @summary Queue a batch of ToTeach worksheet imports for the current user
 */
export const useCreateToTeachWorksheetImportBatch = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToTeachWorksheetImportBatch>>, TError,CreateToTeachWorksheetImportBatchMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createToTeachWorksheetImportBatch>>,
        TError,
        CreateToTeachWorksheetImportBatchMutationVariables,
        TContext
      > => {
      return useMutation(getCreateToTeachWorksheetImportBatchMutationOptions(options), queryClient);
    }
